import { connect } from 'react-redux';
import { closeToast } from 'Store/toast/toast.actions';
import { Toast } from './Toast';
type ContainerProps = {
  color: string;
  icon: string;
  label: string;
  visible: boolean;
};
export const mapStateToProps = (state: ReduxState = {}): ContainerProps => {
  const { className, color, icon, label, shouldDisplay, style } = state.toast || {};
  return {
    className,
    color,
    icon,
    label,
    style,
    visible: shouldDisplay,
  };
};
const mapDispatchToProps = {
  onClose: closeToast,
};
export const ToastContainer = connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Toast);
